import { connect } from 'react-redux';
import MiniPlayer from './mini-player.component';

const mapStateToProps = ({ player, app }) => ({
  isMiniPlayerOpen: Number.isInteger(player.activeIndex),
  playback: app.config?.playback,
});

export default connect(mapStateToProps)(MiniPlayer);
